import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {UnrSettingsService} from '../../services/settings/settings.service';

@Injectable({providedIn: 'root'})
export class WelcomeGuard implements CanActivate {

  set hasSeenWelcomeScreen(value: boolean) {
    this._hasSeenWelcomeScreen = value;
  }

  private _hasSeenWelcomeScreen = false;

  constructor(private router: Router,
              private settingsService: UnrSettingsService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const hasNotSeenWelcomeScreen = this._hasSeenWelcomeScreen === false;
    const shouldShowWelcomeScreen = this.settingsService.getShowWelcomeScreen();
    const canActivate = hasNotSeenWelcomeScreen || shouldShowWelcomeScreen;
    if (!canActivate) {
      this.router.navigate(['roadtrips']);
    }
    return canActivate;
  }
}
